




























































































































































































































































import { EventSceneManagementEventSceneService as eventScene } from "@/common/api";
import { EventSceneManagementEventSceneDTO } from "@/common/api/models/EventSceneManagementEventSceneDTO";
import QNotify from "@/common/qNotify";
import { formatImageUrl } from "@/common/utils";
import EventRemoteSettingComponent from "@/components/admin/eventRemote/eventRemoteSettingComponent.vue";
import {
  EventItemStatuses,
  quantities,
  QuantitieValues,
  sceneTypes,
} from "@/components/admin/eventRemote/eventRemoteType";
import { Component, Vue } from "vue-property-decorator";

@Component({
  name: "EventRemoteComponent",
  components: {
    EventRemoteSettingComponent,
  },
})
export default class EventRemoteComponent extends Vue {

  get oneEventItem() {
    const isOne = this.eventScene.event_items.length === 1;
    if (isOne) {
      return this.eventScene.event_items[0];
    }
    return null;
  }
  get multiEventItems() {
    const isMoreThanOne = this.eventScene.event_items.length > 1;
    if (isMoreThanOne) {
      return this.eventScene.event_items;
    }
    return null;
  }

  get canChangeSetting() {
    return !this.isLoading && this.eventScene.can_setting;
  }
  get canStart() {
    return (
      !this.isLoading &&
      this.eventScene.can_start &&
      !this.eventScene.is_editing
    );
  }
  get canGoNextOrPrev() {
    return !this.isLoading;
  }
  get disableStyle() {
    return {
      cursor: "not-allowed",
      pointerEvents: "none",
      opacity: 0.5,
    };
  }
  get ableStyle() {
    return {
      cursol: "pointer",
      pointerEvents: "auto",
      opacity: 1,
    };
  }

  get masterSceneTypes() {
    return sceneTypes;
  }

  public get getYokyoUrl(): string {
    const images = this.eventScene.event_images;
    const imageId = this.eventScene.event_image_id;
    const targetImage = images.find((image) => image.id === imageId);

    let filename = null;

    if (targetImage) {
      filename = targetImage.image_name;
    }

    return formatImageUrl(filename, "1000x1000", "outside");
  }

  get quantityOptions() {
    return [
      { text: "1", value: quantities.one },
      { text: "5", value: quantities.five },
      { text: "10", value: quantities.ten },
    ];
  }

  public get isEnded(): boolean {
    return this.eventScene.event.is_end;
  }
  public $refs: {
    EventRemoteSettingComponentRef: InstanceType<
      typeof EventRemoteSettingComponent
    >;
  };
  public isLoading = false;
  public isProgressLottery = false;
  public eventScene: EventSceneManagementEventSceneDTO = null;

  public isUploadingYokyo = false;

  public setting: {
    requestQuantity: QuantitieValues;
    isApplyQuantityToNext: boolean;
    type: string;
  } = {
    requestQuantity: null,
    isApplyQuantityToNext: false,
    type: "",
  };

  public errorRemoteSetting: string | null = null;

  public quantities = quantities;

  // タイマーIDを管理
  private timers: number[] = [];

  private audio = null;
  private jyan = null;
  private yokyo = null;
  private dummy = null;
  private fanfare = null;

  public async mounted() {
    const eventId = this.$route.params.id;
    await this.getEventScene({ eventId });
  }

  public beforeDestroy() {
    // 全てのタイマーをクリア
    this.timers.forEach((timerId) => clearTimeout(timerId));
    this.timers = [];

    // 音声リソースを解放
    this.cleanupAudio();
  }
  public async startLottery() {
    if (this.isProgressLottery || this.isLoading) {
      return;
    }

    // 前回のタイマーをクリア
    this.timers.forEach((timerId) => clearTimeout(timerId));
    this.timers = [];

    // 音声を停止してリセット
    const audioObjects = [this.audio, this.jyan, this.yokyo, this.dummy, this.fanfare];
    audioObjects.forEach((audio) => {
      if (audio) {
        audio.pause();
        audio.currentTime = 0;
      }
    });

    this.playEndrollSound();
    try {
      this.isLoading = true;
      const result = await eventScene.adminEventSceneStartLottery({
        eventId: this.eventScene.event.id,
        eventSceneId: this.eventScene.id,
      });
      if (result.status === "error") {
        QNotify.error({
          text: result.message,
        });
        return;
      }
      this.isProgressLottery = true;
      this.eventScene = result.data.eventScene;
      this.setTimerToStopLottery(this.eventScene.type);
    } catch (error) {
      QNotify.error({
        text: error.body?.message || error.message || "エラーが発生しました",
      });
    } finally {
      this.isLoading = false;
    }
  }

  public async getEventScene(query) {
    try {
      this.isLoading = true;
      const result = await eventScene.adminEventSceneListInit(query);
      if (result.status === "error") {
        QNotify.error({
          text: result.message,
        });
        return;
      }
      this.eventScene = result.data.eventScene;
      await this.setStatusDoneIfStillShow(this.eventScene.status);
    } catch (error) {
      QNotify.error({
        text: error.body?.message || error.message || "エラーが発生しました",
      });
    } finally {
      this.isLoading = false;
    }
  }

  public async getNextEventScene() {
    if (this.isProgressLottery || this.isLoading) {
      return;
    }
    try {
      this.isLoading = true;
      const result = await eventScene.adminEventSceneListNext({
        eventId: this.eventScene.event.id,
        currentEventSceneId: this.eventScene.id,
      });
      if (result.status === "error") {
        QNotify.error({
          text: result.message,
        });
        return;
      }
      if (result.data.eventScene === null) {
        QNotify.error({
          text: "次の抽選はありません",
        });
        return;
      }
      this.eventScene = result.data.eventScene;
      await this.setStatusDoneIfStillShow(this.eventScene.status);
    } catch (error) {
      QNotify.error({
        text: error.body?.message || error.message || "エラーが発生しました",
      });
    } finally {
      this.isLoading = false;
    }
  }

  public async getPrevEventScene() {
    if (this.isProgressLottery || this.isLoading) {
      return;
    }
    try {
      this.isLoading = true;
      const result = await eventScene.adminEventSceneListPrev({
        eventId: this.eventScene.event.id,
        currentEventSceneId: this.eventScene.id,
      });
      if (result.status === "error") {
        QNotify.error({
          text: result.message,
        });
        return;
      }
      if (result.data.eventScene === null) {
        QNotify.error({
          text: "前の抽選はありません",
        });
        return;
      }
      this.eventScene = result.data.eventScene;
      await this.setStatusDoneIfStillShow(this.eventScene.status);
    } catch (error) {
      QNotify.error({
        text: error.body?.message || error.message || "エラーが発生しました",
      });
    } finally {
      this.isLoading = false;
    }
  }

  public async updateIsEditing(value: boolean) {
    if (this.isProgressLottery || this.isLoading) {
      return;
    }
    try {
      this.isLoading = true;
      const result = await eventScene.adminEventSceneUpdateIsEditing({
        eventId: this.eventScene.event.id,
        eventSceneId: this.eventScene.id,
        isEditing: value,
      });
      if (result.status === "error") {
        QNotify.error({
          text: result.message,
        });
        return;
      }
      this.eventScene = result.data.eventScene;
      QNotify.success({
        text: "更新しました",
      });
    } catch (error) {
      QNotify.error({
        text: error.body?.message || error.message || "エラーが発生しました",
      });
    } finally {
      this.isLoading = false;
    }
  }

  public async saveSettings(settings: {
    requestQuantity: QuantitieValues;
    isApplyQuantityToNext: boolean;
    type: string;
    selectedEventImageId: number | null;
  }) {
    if (this.isProgressLottery || this.isLoading) {
      return;
    }
    this.errorRemoteSetting = null;

    try {
      this.isLoading = true;

      const result = await eventScene
        .adminEventSceneUpdate({
          eventId: this.eventScene.event.id,
          eventSceneId: this.eventScene.id,
          isEditing: this.eventScene.is_editing,
          requestQuantity: settings.requestQuantity,
          isApplyQuantityToNext: settings.isApplyQuantityToNext,
          type: settings.type,
          eventImageId: settings.selectedEventImageId,
        })
        .catch((error) => {
          this.errorRemoteSetting = error.body?.message;
          throw error;
        });
      this.$refs.EventRemoteSettingComponentRef.close();

      this.eventScene = result.data.eventScene;
      QNotify.success({
        text: "設定を更新しました",
      });
    } catch (error) {
      QNotify.error({
        text: error.body?.message || error.message || "エラーが発生しました",
      });
    } finally {
      this.isLoading = false;
    }
  }

  public handleChangeType(type: string) {
    if (type !== this.masterSceneTypes.正札モード) {
      this.eventScene.quantity = quantities.one;
    }
    const setting = {
      requestQuantity: this.eventScene.quantity as QuantitieValues,
      isApplyQuantityToNext: false,
      type,
      selectedEventImageId: this.eventScene.event_image_id,
    };
    this.saveSettings(setting);
  }

  public handleChangeTypeYokyo() {
    this.isUploadingYokyo = true;
    this.$refs.EventRemoteSettingComponentRef.uploadImage();
  }
  public uploadedEventImage(imageId: number) {
    if (!this.isUploadingYokyo) { return; }
    this.isUploadingYokyo = false;

    const setting = {
      requestQuantity: 1 as QuantitieValues,
      isApplyQuantityToNext: false,
      type: this.masterSceneTypes.余興モード,
      selectedEventImageId: imageId,
    };
    this.saveSettings(setting);
  }
  public handleChangeQuantity() {
    if (this.eventScene.quantity !== this.quantities.one) {
      this.eventScene.type = this.masterSceneTypes.正札モード;
    }

    const setting = {
      requestQuantity: this.eventScene.quantity as QuantitieValues,
      isApplyQuantityToNext: false,
      type: this.eventScene.type,
      selectedEventImageId: null,
    };
    this.saveSettings(setting);
  }
  public isChangableType(): boolean {
    return this.eventScene.quantity === this.quantities.one;
  }

  public itemStatusDisplay(status: string): string {
    switch (status) {
      case EventItemStatuses.soldout:
        return "抽選対象外：抽選外販売";
      case EventItemStatuses.cancel:
        return "抽選対象外：中止";
      case EventItemStatuses.release:
        return "抽選対象外：申し込みなし";
    }
    return "抽選対象外";
  }

  public desplayWinnerInfo(item): string {
    if (this.eventScene.status !== "done") {
      return "";
    }
    return item.winner;
  }

  public confirmCancel() {
    this.$modal.showDelete({
      title: "イベント終了確認",
      text: "終了すると、抽選結果発表画面は表示されません。",
      confirmText: "終了",
      onConfirm: () => {
        this.handleEndEvent();
      },
    });
  }

  public async handleEndEvent() {
    if (this.isProgressLottery || this.isLoading) {
      return;
    }
    try {
      this.isLoading = true;
      const result = await eventScene.adminEventSceneEndEvent({
        eventId: this.eventScene.event.id,
      });
      if (result.status === "error") {
        QNotify.error({
          text: result.message,
        });
        return;
      }
      this.eventScene.event.is_end = true;
      QNotify.success({
        text: "イベントを終了しました",
      });
    } catch (error) {
      QNotify.error({
        text: error.body?.message || error.message || "エラーが発生しました",
      });
    } finally {
      this.isLoading = false;
    }
  }

  private cleanupAudio() {
    const audioObjects = [this.audio, this.jyan, this.yokyo, this.dummy, this.fanfare];
    audioObjects.forEach((audio) => {
      if (audio) {
        audio.pause();
        audio.src = "";
        audio.load();
      }
    });
    this.audio = null;
    this.jyan = null;
    this.yokyo = null;
    this.dummy = null;
    this.fanfare = null;
  }

  private async setTimerToStopLottery(type: string) {
    const time = type === sceneTypes.囮札モード ? 9_000 : 5_000;
    if (this.isProgressLottery) {
      const timerId = window.setTimeout(() => {
        this.stopLottery();
      }, time);
      this.timers.push(timerId);
    }
  }

  private async stopLottery() {
    try {
      this.isLoading = true;
      const result = await eventScene.adminEventSceneStopLottery({
        eventId: this.eventScene.event.id,
        eventSceneId: this.eventScene.id,
      });
      this.isProgressLottery = false;

      if (result.status === "error") {
        QNotify.error({
          text: result.message,
        });
        return;
      }

      this.eventScene = result.data.eventScene;
    } catch (error) {
      QNotify.error({
        text: error.body?.message || error.message || "エラーが発生しました",
      });
    } finally {
      this.isLoading = false;
    }
  }
  private playEndrollSound() {
    if (!this.audio) {
      this.audio = new Audio("/sounds/drum-roll.mp3");
      this.jyan = new Audio("/sounds/jyan.mp3");
      this.yokyo = new Audio("/sounds/yokyo.mp3");
      this.dummy = new Audio("/sounds/dummy.mp3");
      this.fanfare = new Audio("/sounds/fanfare.mp3");
    }
    this.audio.currentTime = 0;
    this.audio.play().catch((error) => {
      console.error("Audio playback failed:", error);
    });

    const timerId1 = window.setTimeout(() => {
      this.audio.pause();
      const sound =
        this.eventScene.type === sceneTypes.囮札モード
          ? this.dummy
          : this.jyan;

      sound.currentTime = 0;
      sound.play().catch((error) => {
        console.error("Audio replay failed:", error);
      });
    }, 5300);
    this.timers.push(timerId1);

    if (this.eventScene.type === sceneTypes.囮札モード) {
      const timerId2 = window.setTimeout(() => {
        this.audio.pause();
        this.jyan.currentTime = 0;
        this.jyan.play().catch((error) => {
          console.error("Audio replay failed:", error);
        });
        const timerId3 = window.setTimeout(() => {
          this.fanfare.play().catch((error) => {
            console.error("Audio replay failed:", error);
          });
        }, 2500);
        this.timers.push(timerId3);
      }, 8500);
      this.timers.push(timerId2);
    } else {
      const timerId4 = window.setTimeout(() => {
        if (
          this.eventScene.status === "show" ||
          this.eventScene.status === "done"
        ) {
          this.fanfare.currentTime = 0;
          this.fanfare.play().catch((error) => {
            console.error("Audio replay failed:", error);
          });
        } else if (
          this.eventScene.status === "show_yokyo" ||
          this.eventScene.status === "done_yokyo"
        ) {
          this.yokyo.currentTime = 0;
          this.yokyo.play().catch((error) => {
            console.error("Audio replay failed:", error);
          });
        }
      }, 6300);
      this.timers.push(timerId4);
    }
  }

  /**
    画面リロードまたは何かしらの問題が起きてstopLotteryが呼ばれなかった場合、
    status が show or show_yokyo のままなので、
    抽選を表示したときにステータスを done or done_yokyo に変更する。
  */
  private async setStatusDoneIfStillShow(status) {
    if (this.isProgressLottery) { return; }

    if (status === "show" || status === "show_yokyo") {
      await this.stopLottery();
    }
  }
}
